// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width: 575px){.step-item[data-v-1dc8e134]{flex:0;margin-bottom:0}.step-icon[data-v-1dc8e134]::after{display:none}.card-header[data-v-1dc8e134]{padding-bottom:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
